import olPolygon from 'ol/geom/Polygon.js';
import olFormatGeoJSON from 'ol/format/GeoJSON.js';

import mapbsRealestateadress from 'mapbs/components/realestateinformation/model/mapbsrealestateadressmodel';

export default class mapbsRealestatebuilding {
    constructor() {
        /**@type {number} */
        this.buildingId = 0;
        /**@type {number} */
        this.egid = 0;
        /**@type {string} */
        this.buildingStatus = '';
        /**@type {string} */
        this.category = '';
        /**@type {Array<mapbsRealestateadress>} */
        this.addresses = [];
        /**@type {boolean} */
        this.containsAddressesOutsideRE = 0;
        /**@type {number} */
        this.addressesOnReCount = 0;
        /**@type {number} */
        this.addressesOutsideReCount = 0;
        /**@type {olPolygon} */
        this.geometry = null;
    }

    getRealestateBuildingObject(jsonObj) {
        this.buildingId = jsonObj['BuildingId'];
        this.egid = jsonObj['EGID'];
        this.buildingStatus = jsonObj['BuildingStatus'];
        this.category = jsonObj['Category'];
        this.addresses = this.getAdresses(jsonObj['Adress']);
        this.addressesOnReCount = this.addresses.filter(x => x.containedByRealEstate).length;
        this.addressesOutsideReCount = this.addresses.filter(x => x.containedByRealEstate === false).length;
        this.containsAddressesOutsideRE = this.addressesOutsideReCount > 0;
        this.mapbs3dLink = jsonObj['Links']['MapBS3D'];

        if ('Geometry' in jsonObj) {
            const geojson = new olFormatGeoJSON();
            this.geometry = geojson.readFeature(jsonObj['Geometry']);
            this.geometry.set('name', this.buildingId.toString());
            this.geometry.set('type', 'building');
        }
    }

    getAdresses(jsonObj) {
        const addresses = [];
        jsonObj.forEach(element => {
            const address = new mapbsRealestateadress();
            address.getRealestateAdressObject(element);
            if(address.status === 'aktiv'){
                addresses.push(address);
            }
        });
        return addresses;
    }
}
